{
  "clear": "נקי",
  "invalid": "(לא חוקי)",
  "loading": "טוען...",
  "noResults": "אין תוצאות",
  "valid": "(תָקֵף)"
}
